import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class ArcStatsDto {
  @Field(t => Int)
  userId!: number

  @Field(type => Int)
  arcCount!: number
}
